module.exports = __webpack_public_path__ + "img/product5.4de33d4c.png";